import { render, staticRenderFns } from "./CompareStatusPanel.vue?vue&type=template&id=246c5d0d&scoped=true&"
import script from "./CompareStatusPanel.vue?vue&type=script&lang=js&"
export * from "./CompareStatusPanel.vue?vue&type=script&lang=js&"
import style0 from "./CompareStatusPanel.vue?vue&type=style&index=0&id=246c5d0d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246c5d0d",
  null
  
)

export default component.exports